import SelectorEngine from '../../utils/dom/selector-engine';
import Request, { ApiMode } from '../../utils/request';
import FormGenerator, { FormTypes } from '../../components/FormGenerator';

const SELECTOR_WRAPPER = '.p-lta-player-details';
const SELECTOR_QUESTION = '.p-player-details-questions';

const IS_LOCAL = false;
const KEY_OBJECT = 'fieldName';

class PlayerDetails {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	get stepsData() {
		return this._stepsData;
	}

	set stepsData(_stepsData) {
		this._stepsData = _stepsData;
		if (_stepsData?.length > 0) {
			this.initiateFormGenerator(_stepsData);
		}
	}

	init() {
		this.questions = SelectorEngine.findOne(SELECTOR_QUESTION, this.step);
		this.fetchSteps();
	}
	async fetchSteps() {
		try {
			const url = '/api/player/getDetails';
			const response = await Request.get(
				url,
				{},
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { Steps, error } = response;
			if (Steps) {
				this.stepsData = Steps;
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			console.log('error', error);

			if (error.hasError) {
				console.log('Error : ', error);
			}
		}
	}

	initiateFormGenerator(stepsData) {
		this.formGenerator = new FormGenerator(this.questions, {
			questions: stepsData,
			totalSteps: 1,
			hasSeparator: false,
			formType: FormTypes.StepForm,
			themeColor: '--color-white',
			radioAnswerField: 'id',
			isBackButtonEnabled: true,
			isHideProgress: false,
			mainPageElement: this.step,
			stepVisibility: [false]
		});
	}

	async saveData(payload) {
		try {
			let url = '/api/myaccreditationDetails/updatereview';
			const apiResponse = await Request.post(url, payload, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
				}
			});
			const { success } = apiResponse;
			if (success) {
				window.location.href = this.redirectUrl;
			}
		} catch (error) {
			console.error(error);
		}
	}

	handleModalExit() {
		// Go back to the page that launched the modal
		history.back();
	}

	getAnswerByFieldName(answers, filedName) {
		const question = this.formGenerator.questions.find((question) => question?.[KEY_OBJECT] === filedName);
		if (question) {
			return answers?.[question.step]?.[question?.id]?.value;
		}
		return null;
	}
}

const globalPlayerDetails = new PlayerDetails();
export default globalPlayerDetails;
